module.exports = __webpack_public_path__ + "img/demand.22d5da7d.svg";